import {Box, TextField, Typography} from "@mui/material";
import {platforms, resolutions} from "./AssetsConfig";

interface IResource {
    config: any
    platform: string
    resolution: string
}
function Resource({config, platform, resolution}: IResource) {
    const getAssets: any = (config: any, platform: string, variable: string) => {
        if (config.resource_registry[platform].jsn_inherit) {
            return {
                ...getAssets(config, config.resource_registry[platform].jsn_inherit, variable),
                ...config.resource_registry[platform][variable]
            };
        }
        return {
            ...config.resource_registry[platform][variable]
        };
    }
    const video_level = getAssets(config, platform, "video_level");

    return (
        <TextField label={`${platform} ${resolution}`} size="small" sx={{margin: 1}}
                   value={video_level[resolution] || ""}/>
    );
}
interface IVideoResources {
    config: any
    project: string
}
export function VideoResources({config, project}: IVideoResources) {
    return (
        <Box display="flex" flexDirection="column">
            <Typography>
                This details where touch video downloads the resource for each platform and resolution from AWS.
            </Typography>
            <TextField label="Base Url" size="small" sx={{flexGrow: 1, margin: 1}}
                       value={config.resource_registry.base.url}/>
            <Box display="flex">
                {resolutions.map(resolution =>
                    <Box display="flex" flexDirection="column" flexGrow={1} key={resolution}>
                        {platforms.map(platform =>
                            <Resource config={config} platform={platform} key={platform} resolution={resolution}/>
                        )}
                    </Box>
                )}
            </Box>
        </Box>
    );
}